import React from 'react';

export const DishesIcon = ({
  width = '24',
  height = '24',
  fill = '#0F2664',
}) => {
  return (
    <div className="feature">
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19.9996 7.60079H22.8252C22.484 7.97837 21.9376 8.4008 21.1996 8.4008H20.5996C20.3784 8.4008 20.1996 8.58 20.1996 8.80078C20.1996 9.02156 20.3784 9.20076 20.5996 9.20076H21.1996C23.0256 9.20076 23.9204 7.45398 23.9575 7.37959C24.0196 7.25561 24.0128 7.10837 23.94 6.99039C23.8667 6.87278 23.7384 6.80078 23.5996 6.80078H19.9996C19.7784 6.80078 19.5996 6.97998 19.5996 7.20076C19.5996 7.42159 19.7784 7.60079 19.9996 7.60079Z"
          fill={fill}
        />
        <path
          d="M15.5999 11.5999C15.3787 11.5999 15.1999 11.7791 15.1999 11.9999C15.1999 14.867 12.8672 17.1998 10 17.1998C7.13282 17.1998 4.80001 14.8671 4.80001 11.9999C4.80001 9.13273 7.13277 6.79996 9.99995 6.79996C10.2212 6.79996 10.3999 6.62076 10.3999 6.39998C10.3999 6.1792 10.2212 6 9.99995 6C6.69159 6 4 8.69159 4 12C4 15.3083 6.69159 17.9999 9.99995 17.9999C13.3083 17.9999 15.9999 15.3083 15.9999 12C15.9999 11.7791 15.8211 11.5999 15.5999 11.5999Z"
          fill={fill}
        />
        <path
          d="M11.4852 7.01605C13.174 7.51803 14.4816 8.82603 14.9844 10.514C15.036 10.6876 15.1948 10.8004 15.3676 10.8004C15.4052 10.8004 15.4436 10.7949 15.4816 10.7837C15.6932 10.7205 15.814 10.4977 15.7508 10.2861C15.1712 8.33768 13.6616 6.82888 11.7132 6.24933C11.5016 6.18572 11.2789 6.30731 11.216 6.51853C11.1528 6.73007 11.2736 6.95287 11.4852 7.01605Z"
          fill={fill}
        />
        <path
          d="M23.5998 18.8008H18.3998C18.1786 18.8008 17.9998 18.98 17.9998 19.2008C17.9998 19.4215 18.1786 19.6007 18.3998 19.6007H22.8254C22.4842 19.9783 21.9378 20.4008 21.1997 20.4008H17.1998C17.121 20.4008 17.0434 20.4243 16.9778 20.468L15.8786 21.2008H15.1998C14.9786 21.2008 14.7998 21.38 14.7998 21.6007C14.7998 21.8215 14.9786 22.0007 15.1998 22.0007H15.9998C16.0786 22.0007 16.1562 21.9771 16.2218 21.9335L17.321 21.2007H21.1998C23.0258 21.2007 23.9206 19.4539 23.9577 19.3795C24.0198 19.2556 24.013 19.1083 23.9402 18.9903C23.867 18.8728 23.7386 18.8008 23.5998 18.8008Z"
          fill={fill}
        />
        <path
          d="M23.5996 10.8008H20.9996C20.7784 10.8008 20.5996 10.98 20.5996 11.2008C20.5996 11.4215 20.7784 11.6007 20.9996 11.6007H22.8252C22.484 11.9783 21.9376 12.4008 21.1996 12.4008H20.9996C20.7784 12.4008 20.5996 12.58 20.5996 12.8007C20.5996 13.0215 20.7784 13.2007 20.9996 13.2007H21.1996C23.0256 13.2007 23.9204 11.4539 23.9576 11.3795C24.0196 11.2556 24.0128 11.1083 23.94 10.9903C23.8668 10.8728 23.7384 10.8008 23.5996 10.8008Z"
          fill={fill}
        />
        <path
          d="M23.5996 14.8008H20.5996C20.3784 14.8008 20.1997 14.98 20.1997 15.2008C20.1997 15.4215 20.3784 15.6007 20.5996 15.6007H22.8252C22.484 15.9783 21.9376 16.4008 21.1996 16.4008H19.9996C19.7784 16.4008 19.5996 16.58 19.5996 16.8007C19.5996 17.0215 19.7784 17.2007 19.9996 17.2007H21.1996C23.0256 17.2007 23.9204 15.4539 23.9575 15.3795C24.0196 15.2556 24.0128 15.1083 23.94 14.9903C23.8668 14.8728 23.7384 14.8008 23.5996 14.8008Z"
          fill={fill}
        />
        <path
          d="M19.9999 11.9999C19.9999 6.48595 15.5139 2 9.99995 2C4.486 2 0 6.48595 0 11.9999C0 17.5139 4.48595 21.9998 9.99991 21.9998C15.5139 21.9998 19.9999 17.5139 19.9999 11.9999ZM9.99991 21.1998C4.92676 21.1998 0.799963 17.0726 0.799963 11.9999C0.799963 6.92709 4.92676 2.79996 9.99991 2.79996C15.0731 2.79996 19.1999 6.92713 19.1999 11.9999C19.1999 17.0727 15.0731 21.1998 9.99991 21.1998Z"
          fill={fill}
        />
      </svg>
    </div>
  );
};
